export default {
  "head.index": "Accueil",
};
